import styled from "styled-components";

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 640px;
  font-family: "Geist", sans-serif;
  color: #181d27;

  .panel-heading {
    margin: 0 0 4px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.2px;
  }

  .setting-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 0;
    border-bottom: 0.909px solid rgba(0, 0, 0, 0.06);
  }

  .setting-row.stacked {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .setting-row.last {
    border-bottom: none;
  }

  .label {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #181d27;
  }

  .hint {
    margin: 2px 0 0;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 260px;
    flex-shrink: 0;
  }

  .email-value {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
    overflow-wrap: anywhere;
    text-align: right;
  }

  .field-error {
    font-size: 12px;
    line-height: 18px;
    color: #b42318;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 16px;
  }

  @media (max-width: 768px) {
    .setting-row {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }

    .field {
      width: 100%;
    }

    .email-value {
      text-align: left;
    }
  }
`;

export const TextInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 0.909px solid
    ${({ $invalid }) => ($invalid ? "#b42318" : "rgba(0, 0, 0, 0.09)")};
  border-radius: 8px;
  background: #fff;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  letter-spacing: -0.1px;
  color: #181d27;

  &::placeholder {
    color: #a3a7ae;
  }

  &:focus {
    outline: none;
    border-color: #181d27;
  }
`;

export const BioInput = styled.textarea`
  width: 100%;
  min-height: 88px;
  padding: 10px 12px;
  border: 0.909px solid
    ${({ $invalid }) => ($invalid ? "#b42318" : "rgba(0, 0, 0, 0.09)")};
  border-radius: 8px;
  background: #fff;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.1px;
  color: #181d27;
  resize: vertical;

  &::placeholder {
    color: #a3a7ae;
  }

  &:focus {
    outline: none;
    border-color: #181d27;
  }
`;

export const AvatarButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  padding: 0;
  border: none;
  border-radius: 28px;
  background: #f5f5f5;
  font-family: "Geist", sans-serif;
  font-size: 16px;
  letter-spacing: -0.2px;
  color: #414651;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }

  .avatar-image {
    width: 100%;
    height: 100%;
    border-radius: 28px;
    object-fit: cover;
  }

  .camera-badge {
    position: absolute;
    right: -2px;
    bottom: -2px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: 1.818px solid #fff;
    border-radius: 11px;
    background: #181d27;
  }

  .avatar-loader {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.7);
  }
`;

const buttonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 8px 14px;
  border-radius: 8px;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const DarkButton = styled.button`
  ${buttonBase}
  border: 1px solid #181d27;
  background: #181d27;
  color: #fff;
`;

export const OutlineButton = styled.button`
  ${buttonBase}
  border: 0.909px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  color: #181d27;
`;
